
import { Component, OnInit, OnDestroy, signal } from '@angular/core';

import { MonitorsTableComponent } from '/app/monitors/components/monitors-table/monitors-table.component';
import { MonitorsService } from '/app/monitors/services/monitors.service';
import { Monitor } from '/app/monitors/models/monitor.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { AlarmsTableComponent } from '/app/alarms/components/alarms-table/alarms-table.component';
import { AlarmsDetailsComponent } from '/app/alarms/components/alarms-details/alarms-details.component';
import { Alarm } from '/app/alarms/models/alarm.model';
import { MonitorsDetailsComponent } from '/app/monitors/components/monitors-details/monitors-details.component';
import { UsersService } from '/app/services/users/users.service';
import { HelpService } from '/app/services/help/help.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertComponent } from '/app/components/alert/alert.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '/app/components/confirm/confirm-dialog/confirm-dialog.component';
import { UsersDetailsComponent } from '/app/users/components/users-details/users-details.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ADMINISTRATORS, SITRACK } from '/app/constants/auth.constants';
import { MonitorsAdminTableComponent } from '/app/monitors/components/monitors-admin-table/monitors-admin-table.component';
import { CorporateService } from '/app/corporates/services/corporate.service';
import { Corporate } from '/app/corporates/models/corporate';
import {CorporatesAdminTableComponent} from '/app/corporates/components/corporates-admin-table/corporates-admin-table.component';
import { HasRoleDirective } from "/app/shared/directives/has-role.directive";

@Component({
  selector: 'app-administracion',
  imports: [
    MonitorsTableComponent,
    AlarmsTableComponent,
    MatIconModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatTooltipModule,
    MatCardModule,
    MonitorsDetailsComponent,
    AlertComponent,
    UsersDetailsComponent,
    MatTabsModule,
    MonitorsAdminTableComponent,
    CorporatesAdminTableComponent,
    HasRoleDirective
],
  templateUrl: './administracion.component.html',
})
export class AdministracionComponent implements OnInit, OnDestroy {
  showAlert = signal(false);
  alertType = signal<'success' | 'error' | 'warning' | 'info'>('info');
  alertMessage = signal('');
  dataSource = signal<Monitor[]>([]);
  dataCorporate = signal<Corporate[]>([]);
  isLoading = signal(false);
  error = signal<string | null>(null);
  selectedMonitorId = signal<string>("");
  currentMonitorId = signal<string | null>(null);
  currentMonitorName = signal<string | null>(null);
  selectedAlarm = signal<any>(null);
  showAlarmDetails = signal(false);
  showMonitorDetails = signal(false);
  showUsersDetails = signal(false);
  alarmsFromChild = signal<Alarm[]>([]);
  monitorsFromChild: Monitor[] = [];

  isAdministrator = signal(false);
  isSitrackAdministrator = signal(false);
  userLoginName = signal('');
  private destroy$ = new Subject<void>();

  constructor(
    private monitorsService: MonitorsService,
    private authService: UsersService,
    private corporateService: CorporateService,
    private helpService: HelpService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    const userInfo = this.authService.getUserInfo();

    if (userInfo) {
      this.userLoginName.set(this.decodeUTF8(userInfo.fullName));

      this.isAdministrator.set(userInfo.groups.some((group: string) =>
        ADMINISTRATORS.includes(group)
      ));

      this.isSitrackAdministrator.set(userInfo.groups.some((group: string) =>
        SITRACK.includes(group)
      ));
     
    }

    setTimeout(() => {
      this.loadMonitors();
    }, 100);


    this.loadCorporates();

    this.activatedRoute.params.subscribe((params) => {
      if (params['monitorId']) {
        this.selectedMonitorId.set(params['monitorId']);
        this.currentMonitorId.set(params['monitorId']);
        setTimeout(() => {
          const monitor = this.dataSource().find((m) => m.id === params['monitorId']);
          if (monitor) {
            this.currentMonitorName.set(monitor.name);
          }
        }, 500);
      }
    });
  }

  private decodeUTF8(str: string): string {
    try {
      return decodeURIComponent(escape(str));
    } catch (e) {
      return str;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadMonitors(): void {
    this.isLoading.set(true);
    this.error.set(null);
    this.monitorsService.getMonitors().subscribe({
      next: (data: any) => {
        this.dataSource.set(data as Monitor[]);
        this.isLoading.set(false);
      },
      error: (err: any) => {
        this.error.set('Error al cargar los monitores: ' + (err?.message || String(err)));
        this.isLoading.set(false);
      },
    });
  }

  loadCorporates(): void {
    this.isLoading.set(true);
    this.error.set(null);
    this.corporateService.getCorporates().subscribe({
      next: (data) => {    
        this.dataCorporate.set(data as Corporate[]);        
        this.isLoading.set(false);
      },
      error: (err) => {
        this.error.set('Error al cargar los monitores: ' + err.message);
        this.isLoading.set(false);
      },
    });
  }

  //  loadCorporates(): void {
  //   this.isLoading = true;
  //   this.error = null;
  //   this.monitorsService.getMonitors().subscribe({
  //     next: (data) => {
  //       // Corporates loaded (log removed)
  //       this.dataSource = data as Monitor[];
  //       this.isLoading = false;
  //     },
  //     error: (err) => {
  //       this.error = 'Error al cargar los monitores: ' + err.message;
  //       this.isLoading = false;
  //     },
  //   });
  // }


  onMonitorSelected(monitor: { id: string; name: string } | null): void {
    if (monitor) {
      this.selectedMonitorId.set(monitor.id);
      this.currentMonitorId.set(monitor.id);
      this.currentMonitorName.set(monitor.name);
      this.showAlarmDetails.set(false);
      this.showMonitorDetails.set(false);
      this.router.navigate(['/monitors', monitor.id]);
    } else {
      this.selectedMonitorId.set("");
      this.currentMonitorId.set(null);
      this.currentMonitorName.set(null);
      this.router.navigate(['/monitors']);
    }
  }

  onAlarmSelected(alarm: any): void {
    this.selectedAlarm.set(alarm);
    this.showMonitorDetails.set(false);
    this.showUsersDetails.set(false);
    this.showAlarmDetails.set(true);
  }

  onAlarmsUpdate(alarms: Alarm[]) {
    this.alarmsFromChild.set(alarms);
  }

  openMonitorConfig() {
    this.showAlarmDetails.set(false);
    this.showUsersDetails.set(false);
    this.showMonitorDetails.set(true);
  }

  openUsersConfig() {
    this.showAlarmDetails.set(false);
    this.showMonitorDetails.set(false);
    this.showUsersDetails.set(true);
  }

  logout() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        title: 'Salida del Sistema',
        message: '¿Estás seguro de salir del sistema?',
        confirmText: 'Sí, Salir',
        cancelText: 'Cancelar',
        icon: 'exit',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.authService.logout();
        this.router.navigate(['/']).then();
      }
    });
  }

  showSuccess(message: string) {
    this.alertType.set('success');
    this.alertMessage.set(message);
    this.showAlert.set(true);
    setTimeout(() => this.showAlert.set(false), 5000);
  }

  showError(message: string) {
    this.alertType.set('error');
    this.alertMessage.set(message);
    this.showAlert.set(true);
    setTimeout(() => this.showAlert.set(false), 5000);
  }

  ayuda() {
    this.activatedRoute.url.subscribe((url) => {
      if (url.length > 0 && url[0].path === 'users') {
        this.helpService.startTour(this.helpService.getUsersManagementHelpSteps(), 'Gestión de Usuarios');
      } else if (url.length > 0 && url[0].path === 'administracion' && url.length > 1) {
        this.helpService.startTour(this.helpService.getMonitoresHelpSteps(), 'Administración');
      } else {
        this.helpService.startTour(this.helpService.getMonitoresHelpSteps(), 'Administración');
      }
    });
  }
}
